export const Zen = {
    // В связи с ограничениями поставшика кол-во комментариев которое может быть отданно <=50
    COMMENT_LIMIT: 50,
}
